var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssign = function SvgAssign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7195 47.1221C46.2378 47.7179 45.626 48.1949 44.9313 48.5161C44.2361 48.8335 43.4813 48.9984 42.7174 49H6.04547C4.49641 49.0144 3.02439 48.3238 2.04335 47.1221C1.59287 46.5757 1.27254 45.9336 1.10668 45.2445C0.96444 44.55 0.96444 43.8338 1.10668 43.1393C3.37579 32.0003 13.1522 24 24.495 24C35.8377 24 45.6141 32.0003 47.8833 43.1393C48.0389 43.842 48.0389 44.5703 47.8833 45.273C47.6479 45.9735 47.2489 46.6075 46.7195 47.1221Z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.9974 8.98656C34.0201 12.6435 31.8229 15.947 28.4464 17.3325C26.8002 17.9953 24.9984 18.1691 23.2563 17.8333C21.5109 17.4803 19.9082 16.619 18.649 15.3573C16.732 13.4449 15.7756 10.7693 16.0447 8.07175C16.3138 5.37424 17.7799 2.9414 20.0367 1.44736C21.5435 0.48108 23.2995 -0.0218228 25.0881 0.000726372C27.4641 0.00349927 29.7412 0.954514 31.4162 2.64362C32.2755 3.46929 32.9558 4.46369 33.4145 5.56471C33.8275 6.65688 34.0254 7.81891 33.9974 8.98656Z",
    fill: "#FF9800"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assign.2bfec61e.svg";
export { ForwardRef as ReactComponent };